import PaydImg from '@/src/resources/chargeAnytime/payd.svg';
import PaymImg from '@/src/resources/chargeAnytime/paym.svg';
import PaymPremiumImg from '@/src/resources/chargeAnytime/paym-premium.svg';
import PaymMultiPremiumImg from '@/src/resources/chargeAnytime/paym-multi-premium.svg';
import PaymMultiImg from '@/src/resources/chargeAnytime/paym-multi.svg';
import HyundaiImg from '@/src/resources/chargeAnytime/hyundai-partnership-product.svg';
import KiaImg from '@/src/resources/chargeAnytime/kia-partnership-product.svg';

export const IconMapping = {
  payg: PaydImg,
  'payg-volvo': PaydImg,
  'paym-tier-one': PaymImg,
  'paym-tier-two': PaymPremiumImg,
  'paym-multi-tier-one': PaymMultiImg,
  'paym-multi-tier-two': PaymMultiPremiumImg,
  'paym-oem-tier-one': PaymImg, // Default for OEM
  hyundai: HyundaiImg,
  kia: KiaImg,
};
